import CRUD from '../base/crud'

class GroupCRUD extends CRUD {
  getGroupOverview(groupId, params) {
    return this.request({
      method: 'GET',
      url: `${this.url}/${groupId}`,
      params,
    })
  }
}

export default function groupCRUD(request) {
  return new GroupCRUD({
    url: '/group',
    request,
  })
}
